import { makeObservable } from 'mobx';
import { Filtro } from './Filtro';

class FiltroVistor extends Filtro {
    tipo = 'selecao';
    exibicao = 'select';

    get label() {
        return 'Vistor (retorno de vista regimental)';
    }

    constructor(props) {
        super(props);
        makeObservable(this);
    }

    getValorOpcao(registro) {
        let retorno = [];
        let vistas = registro.informacoesAdicionais.RetornoVistaRegimental;

        if (vistas && vistas.length > 0) {
            retorno = vistas.map((vista) => vista.magistrado.sigla);
        }

        return retorno;
    }
}

export default FiltroVistor;
